import React from 'react';
import GroupActionPage from './group-action-page.component';

function GroupCreatePage() {
    return <GroupActionPage isCreateMode={true} />
}

export default GroupCreatePage;
